import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";
import { XeroFinancialSyncGetRequestStatusType } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";

export const XeroSyncRequestStatusMessageBar: React.FC = observer(() => {
  const { notification, customIntegrationXero } = useStores();
  let message = "";
  if (customIntegrationXero.getFinancialSyncRequestStatus !== undefined) {
    if (
      customIntegrationXero.getFinancialSyncRequestStatus ===
      XeroFinancialSyncGetRequestStatusType.PENDING
    ) {
      message = "Loading Xero accounts.";
    } else if (
      customIntegrationXero.getFinancialSyncRequestStatus ===
      XeroFinancialSyncGetRequestStatusType.INTERNALFAILURE
    ) {
      message = "Failed to get response for Xero accounts.";
    }
  }

  useEffect(() => {
    if (
      customIntegrationXero.getFinancialSyncRequestStatus ===
      XeroFinancialSyncGetRequestStatusType.COMPLETED
    ) {
      notification.success("Xero accounts loaded.");
    }
  }, [customIntegrationXero.getFinancialSyncRequestStatus, notification]);

  return message !== "" ? (
    <MessageBar messageBarType={MessageBarType.info}>{message}</MessageBar>
  ) : null;
});
